module.exports = __webpack_public_path__ + "static/media/list.ed2051a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/list.jpg
// module id = 656
// module chunks = 0